import { createSelector } from '@reduxjs/toolkit';
import { getAvailableRoomTypes } from './propertyAvailabilitySelectors';

export const getAvailableRoomTypeCount = createSelector(getAvailableRoomTypes, (availableRoomTypes) => availableRoomTypes.length);
